//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: Better a11y
export default {
  name: 'Modal',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      lastEl: null,
      paddingRight: '0px'
    }
  },

  computed: {
    wrapperClasses() {
      return {
        'flex items-center': this.center
      }
    }
  },

  beforeMount() {
    if (document.activeElement) {
      this.lastEl = document.activeElement
    }

    this.getScrollbarWidth()
  },

  mounted() {
    document.body.style.setProperty('height', '100vh')
    document.body.style.setProperty('overflow', 'hidden')
    document.body.style.setProperty('padding-right', this.paddingRight)

    this.$el.focus()
  },

  beforeDestroy() {
    document.body.style.removeProperty('height')
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('padding-right')
  },

  destroyed() {
    if (this.lastEl) {
      this.lastEl.focus()
    }
  },

  methods: {
    getScrollbarWidth() {
      this.paddingRight =
        window.innerWidth - document.documentElement.offsetWidth + 'px'
    }
  }
}
